export const DASHBOARD_ACTIONS = {
    ORG_USER_STATUS_COUNTS : "ORG_USER_STATUS_COUNTS"
}